import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import { ResponsiveImage } from '@blaze-cms/image-cdn-react';
import Lightbox from './Lightbox';

const ImageRender = ({
  alt,
  imageUrl,
  handleEnableLightbox,
  toggleLightbox,
  displayLightbox,
  enableLightbox,
  caption,
  lightboxImgProps,
  name,
  metaTitle,
  heroModifier,
  style,
  isHero,
  priority,
  sizeKey,
  shouldRenderImgTag,
  ...otherProps
}) => {
  const imageStyle = enableLightbox ? { cursor: 'pointer' } : style;
  const HeadComponent = priority ? Head : null;

  return (
    <>
      {shouldRenderImgTag ? (
        <img style={imageStyle} src={imageUrl} alt={alt} onClick={handleEnableLightbox} />
      ) : (
        <ResponsiveImage
          sizeKey={sizeKey}
          alt={alt}
          src={imageUrl}
          onClick={handleEnableLightbox}
          style={imageStyle}
          HeadComponent={HeadComponent}
        />
      )}

      {displayLightbox && (
        <Lightbox
          imageUrl={imageUrl}
          alt={alt}
          priority={priority}
          closeModal={toggleLightbox}
          caption={caption}
          imgWrapperProps={lightboxImgProps}
          name={metaTitle || name}
          {...otherProps}
        />
      )}
    </>
  );
};

ImageRender.propTypes = {
  displayLightbox: PropTypes.bool.isRequired,
  enableLightbox: PropTypes.bool.isRequired,
  alt: PropTypes.string,
  caption: PropTypes.string,
  imageUrl: PropTypes.string.isRequired,
  name: PropTypes.string,
  heroModifier: PropTypes.string,
  metaTitle: PropTypes.string,
  handleEnableLightbox: PropTypes.func.isRequired,
  toggleLightbox: PropTypes.func.isRequired,
  lightboxImgProps: PropTypes.object.isRequired,
  style: PropTypes.object,
  isHero: PropTypes.bool,
  priority: PropTypes.bool,
  sizeKey: PropTypes.string,
  shouldRenderImgTag: PropTypes.bool
};

ImageRender.defaultProps = {
  name: '',
  metaTitle: '',
  heroModifier: '',
  alt: '',
  caption: '',
  isHero: false,
  priority: false,
  style: {},
  sizeKey: '',
  shouldRenderImgTag: false
};

export default ImageRender;
